import React from 'react';

function Spinner({
	src,
	Icon,
	className = 'w-12 h-12 ml-8',
	style,
}) {
	/* Default values for the styles */
	const defaultStyle = {
		height: '10rem',
		objectFit: 'cover'
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyle = { ...defaultStyle, ...style };

	return <React.Fragment>
		{src && <img
			src={src}
			alt='spinner'
			className={className}
			style={overrideStyle}
		/>}
		{Icon && Icon({
			className,
			style: overrideStyle
		})}
	</React.Fragment>;
}

export default Spinner;
